import * as React from 'react';
import { AnyAction, Dispatch } from 'redux';
import { takeEvery, takeLeading } from 'redux-saga/effects';
import { ShopViewModel as IShopViewModel } from 'stageclip-common';

import { AddShopRequest } from '../api/definitions/addShopRequest';
import { GetAllShopsRequest } from '../api/definitions/getAllShopsRequest';
import * as EntityNormalizers from '../api/normalizers/entityNormalizers';
import * as ShopNormalizers from '../api/normalizers/shopNormalizers';
import { DataRequestActionTypes, InternalActionTypes } from '../constants/actionTypes';

import { RequestAction } from './allActions';
import { FormSubmitAction } from './formActions';
import { runApiRequest } from './saga/sagaActions';

export interface AllShopsLoadedAction extends AnyAction {
  type: InternalActionTypes.AllShopsLoaded;
  result: EntityNormalizers.NormalizedEntityArray<ShopNormalizers.NormalizedShops>;
}

export interface ShopCreatedAction extends AnyAction {
  type: InternalActionTypes.ShopCreated;
  result: EntityNormalizers.NormalizedSingleEntity<ShopNormalizers.NormalizedShops>;
}

export interface RequestAllShopsAction extends RequestAction {
  type: DataRequestActionTypes.AllShopsRequested;
}

export interface AddShopAction extends FormSubmitAction<IShopViewModel> {
  type: DataRequestActionTypes.NewShopRequested;
}

function createAllShopsLoadedAction(
  result: EntityNormalizers.NormalizedEntityArray<ShopNormalizers.NormalizedShops>,
): AllShopsLoadedAction {
  return {
    result,
    type: InternalActionTypes.AllShopsLoaded,
  };
}

function createShopCreatedAction(
  result: EntityNormalizers.NormalizedSingleEntity<ShopNormalizers.NormalizedShops>,
): ShopCreatedAction {
  return {
    result,
    type: InternalActionTypes.ShopCreated,
  };
}

export function createRequestAllShopsAction(component: React.Component, dispatch: Dispatch): RequestAllShopsAction {
  return {
    dispatch,
    requestingComponent: component,
    type: DataRequestActionTypes.AllShopsRequested,
  };
}

function* loadShops(action: RequestAllShopsAction) {
  const request = new GetAllShopsRequest(action.requestingComponent, action.dispatch);
  // @ts-ignore
  yield runApiRequest(request, createAllShopsLoadedAction);
}

function* addShop(action: AddShopAction) {
  const request = new AddShopRequest(action.formData, action.requestingComponent, action.dispatch);
  // @ts-ignore
  yield runApiRequest(request, createShopCreatedAction);
}

export function* createNewShopSaga() {
  yield takeEvery(DataRequestActionTypes.NewShopRequested, addShop);
}

export function* loadShopsSaga() {
  yield takeLeading(DataRequestActionTypes.AllShopsRequested, loadShops);
}
